<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Acción realizada :: <strong>Eliminar</strong></h1>
<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    ¿Esta seguro que desea eliminar el registro {{local_data.descripcion != "" || null ? local_data.descripcion : ""}}?
    <br>
    <br>
    <div class="alert alert-warning" role="alert" *ngIf="esComprobate">
  <div class="alert-header">
    <strong>Importante - Anulación de Comprobantes</strong>
  </div>
  <p>Antes de proceder, tenga en cuenta:</p>
  <ul>
    <li>Si el comprobante tiene movimientos asignados a otros comprobantes, deberá anular todos los relacionados</li>
    <li>Esto incluye tanto recibos como liquidaciones vinculadas</li>
    <li>En casos determinados, los movimientos anulados deberan ser cargados nuevamente para considerarse en el comprobante.</li>
  </ul>
</div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="doAction()"><mat-icon>delete</mat-icon> Eliminar</button>
    <button mat-button (click)="closeDialog()" color="warn">Cancelar</button>
</div>
